import { render } from "./NotificationSvgIcon.vue?vue&type=template&id=61ece1e1"
import script from "./NotificationSvgIcon.vue?vue&type=script&lang=js"
export * from "./NotificationSvgIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__